export default {
    VALIDATED: 'Validated',
    PENDING: 'Pending',
};
